import { render, staticRenderFns } from "./actualizarTelefono.vue?vue&type=template&id=2646658d&scoped=true&"
import script from "./actualizarTelefono.vue?vue&type=script&lang=js&"
export * from "./actualizarTelefono.vue?vue&type=script&lang=js&"
import style0 from "./actualizarTelefono.vue?vue&type=style&index=0&id=2646658d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646658d",
  null
  
)

export default component.exports